import { render } from "./confirm-purchase-tv360.vue?vue&type=template&id=fad1c6ae&scoped=true"
import script from "./confirm-purchase-tv360.vue?vue&type=script&lang=js"
export * from "./confirm-purchase-tv360.vue?vue&type=script&lang=js"

import "./confirm-purchase-tv360.vue?vue&type=style&index=0&id=fad1c6ae&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad1c6ae"]])

export default __exports__